'use client';

import { useSyncExternalStore } from 'react';

// Значение меняется ровно один раз — самим фактом гидратации, поэтому подписка пустая.
const subscribeNever = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `false` на сервере и во время гидратации, `true` после неё.
 * Замена паре `useState(false)` + `useEffect(() => setMounted(true))`:
 * та пара пишет состояние из эффекта и вызывает каскадный ре-рендер.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(subscribeNever, getClientSnapshot, getServerSnapshot);
}
